module.exports = __webpack_public_path__ + "img/reset-password-v2-dark.7f1fd154.svg";